import { useEffect } from 'react';
import { history } from 'routes/history';
import { BASE_PATH } from 'constants';

export const useRedirectToHome = userProfile => {
    useEffect(() => {
        const { name, isAres, dossierFailStatusCode, initialOnboardingRequestFailure } = userProfile;
        if (
            typeof name === 'undefined' &&
            typeof initialOnboardingRequestFailure === 'undefined' &&
            !isAres &&
            !dossierFailStatusCode
        ) {
            history.push(`${BASE_PATH}`);
        }
        window.scrollTo(0, 0);
        // eslint-disable-next-line
    }, []);
};
